import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=3bed70e7&scoped=true&"
import script from "./TermsPage.vue?vue&type=script&lang=js&"
export * from "./TermsPage.vue?vue&type=script&lang=js&"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=3bed70e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed70e7",
  null
  
)

export default component.exports